import React from "react";
import { Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import GlobalStyles from "./StylenColor";

export const ScoreTrendIcon = ({ current, previous, isDesktopWeb }) => {
  const iconSize = isDesktopWeb ? 18 : 12;
  const fontSize = isDesktopWeb
    ? GlobalStyles.fontSize.xsss - 1
    : GlobalStyles.fontSize.xss;

  if (!previous || previous === "NA") {
    return (
      <Text
        style={{
          fontSize,
          color: "#555",
          marginBottom: 2,
          paddingVertical: 1,
          fontFamily: GlobalStyles.inpFont.fontFamily,
        }}
      >
        No previous data
      </Text>
    );
  }

  if (current === previous) {
    return (
      <View
        style={{ flexDirection: "row", alignItems: "center", marginTop: 2 }}
      >
        <Ionicons
          name="remove"
          size={iconSize}
          color="#555"
          style={{ marginRight: 4 }}
        />
        <Text
          style={{
            fontSize,
            color: "#555",
            marginBottom: 2,
            paddingVertical: 1,
            fontFamily: GlobalStyles.GlobalFont.fontFamily,
          }}
        >
          No Change
        </Text>
      </View>
    );
  }

  const isImproved = current > previous;
  const iconName = isImproved ? "arrow-up" : "arrow-down";
  const iconColor = isImproved ? "green" : "red";

  return (
    <View style={{ flexDirection: "row", alignItems: "center", marginTop: 2 }}>
      <Ionicons
        name={iconName}
        size={iconSize}
        color={iconColor}
        style={{ marginRight: 4 }}
      />
      <Text
        style={{
          color: iconColor,
          fontSize,
          marginBottom: 2,
          paddingVertical: 1,
          fontFamily: GlobalStyles.GlobalFont.fontFamily,
        }}
      >
        {isImproved ? "Improved" : "Declined"}
      </Text>
    </View>
  );
};
